import { CircularProgress } from "@mui/material";
import { ThemeInsightsTimelineProps } from "../../../interfaces/themes";
import ThemeInsightItem from "./ThemeInsightItem";

const ThemeInsightsTimeline: React.FC<ThemeInsightsTimelineProps> = ({
  insights,
  category,
  isLoading = false,
  navigationContext,
}) => {
  const title = category?.label ?? insights[0]?.tag ?? "Insights";
  const count = category?.count ?? insights.length;

  return (
    <section
      className={`theme-panel ${
        category ? `theme-panel--${category.key}` : ""
      }`}
      aria-label={`${title} insights`}
    >
      <div className="theme-panel__header">
        <span className="theme-panel__title">
          {count} {title}
        </span>
        {(category?.interactionCount ?? 0) > 0 && (
          <>
            <span className="theme-panel__divider" aria-hidden="true" />
            <span className="theme-panel__meta">
              In {category?.interactionCount ?? insights.length} Interactions
            </span>
          </>
        )}
      </div>
      <div className="theme-panel__scroll">
        {isLoading ? (
          <div className="theme-panel__state" role="status">
            <CircularProgress
              size={24}
              thickness={5}
              aria-label="Loading theme insights"
            />
          </div>
        ) : (
          <div className="theme-timeline">
            <div className="theme-timeline__line" />
            {insights.map((insight, idx) => (
              <ThemeInsightItem
                key={`${insight.id}-${idx}`}
                insight={insight}
                themeKey={category?.key}
                navigationContext={navigationContext}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ThemeInsightsTimeline;
